"use client";

import { IProductInfoClientWrapper } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/ProductInfoClientWrapper/productInfoClientWrapperAdapter";
import { useProductTileClickProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/ProductTileClickContext";

export const useSearchProductInfoClientWrapperProps = ({
  dataTestId,
}: IProductInfoClientWrapper) => {
  const { productLinkProps, onProductClick } = useProductTileClickProps();
  return {
    ...productLinkProps,
    onProductClick,
    "data-test-id": dataTestId ?? "",
  };
};
